import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import FormDialog from '../Dialog'
import './FreeShares.css'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { mapData } from '../../../../product/common/components'
import { useFormik } from 'formik'
import { Link, useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '../../../common/components'

const FreeShares = (props) => {
    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            alreadyCheck: 0,
        },
        onSubmit: (values) => {
            if (values.alreadyCheck == 1) {
                localStorage.setItem('confirmPopup', 'true')
            }
        },
    })

    const alreadyCheck = [
        {
            label: 'Don’t show this message again',
            name: 'alreadyCheck',
            type: 'checkbox',
            class: 'chkBoxWrpr alrdyCmpltd',
            formik: formik,
        },
    ]

    const handleSkip = () => {
        formik.handleSubmit()
        props.openFunction()
    }
    return (
        <FormDialog
            className="freeSharePopup"
            open={props.open}
            openFunction={props.openFunction}
            maxWidth={'sm'}
        >
            {console.log('freeData inside popup', props.data)}
            <div className="freeSharesWrapper">
                <div className="inrFrShrCntnr">
                    <IconButton className="closeBtn" onClick={props.openFunction}>
                        <span className="material-icons">clear</span>
                    </IconButton>
                    <h4>Claim your Free SongShares</h4>
                    <p>You’ve Purchase an NFT and are now able to claim Free SongShares!</p>
                    <p>The following SongShares are free for you to claim</p>
                    <ul>
                        {props.data.length != 0 &&
                            props.data.map((songs, index) => (
                                <li>
                                    <Link to={`/productview/${songs.offerid}/${songs.title}`}>
                                        <span>{songs.title}</span>
                                    </Link>
                                </li>
                            ))}
                    </ul>
                    {props.user?.kycstatus == 'disapproved' ||
                    props.user?.kycstatus == null ||
                    props.user?.amlstatus == null ||
                    props.user?.linkId == null ? (
                        <>
                            <div className="acntSetup">
                                <p>
                                    Before you can claim your Free SongShares, please complete the
                                    setup for your account here
                                </p>
                                <PrimaryButton
                                    label="Account Settings"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'account/profile')
                                    }
                                />
                            </div>
                        </>
                    ) : (
                        ''
                    )}

                    <div className="d-flex align-items-center justify-content-between my-4">
                        <p className="m-0">
                            Please navigate to this page to see the Free SongShares you can claim:
                        </p>
                        <PrimaryButton
                            label="Claim SongShares"
                            onClick={() => handleRedirectInternal(history, 'dashboard')}
                        />
                    </div>
                    <p>
                        As always, you’ll always be able to see Free SongShares that are available
                        to you by navigating to
                    </p>
                    <p className="nvTxt">
                        Open Bids/Offers <img src="/assets/svg/navarrow.svg" className="mx-2" />{' '}
                        Free SongShares
                    </p>
                    <div className="ftrActn">
                        {mapData(alreadyCheck)}
                        <PrimaryButton label="Skip & Close" onClick={() => handleSkip()} />
                    </div>
                </div>
            </div>
        </FormDialog>
    )
}

export default FreeShares
